import { useCallback } from "react";
import type { RefObject } from "react";
import { Platform } from "react-native";
import type { View } from "react-native";

type ScrollIntoViewOptions = {
  behavior?: "smooth" | "auto";
  block?: "start" | "center" | "end" | "nearest";
};

type ScrollTarget = {
  scrollIntoView?: (options?: ScrollIntoViewOptions) => void;
};

const defaultScrollIntoViewOptions: ScrollIntoViewOptions = {
  behavior: "smooth",
  block: "start",
};

export const useScrollIntoView = (
  ref: RefObject<View | null>,
  options: ScrollIntoViewOptions = defaultScrollIntoViewOptions,
) =>
  useCallback(() => {
    if (Platform.OS !== "web") {
      return;
    }

    const mergedOptions: ScrollIntoViewOptions = {
      ...defaultScrollIntoViewOptions,
      ...options,
    };

    (ref.current as ScrollTarget | null)?.scrollIntoView?.(mergedOptions);
  }, [options, ref]);
